import { Component, Input, OnInit } from '@angular/core';
import { AirportActivity } from '../models/airport-activity.model';

@Component({
  selector: 'app-airport-activity',
  templateUrl: './airport-activity.component.html',
  styleUrls: ['./airport-activity.component.scss']
})
export class AirportActivityComponent implements OnInit {
  @Input() activity: AirportActivity;

  constructor() {
  }

  ngOnInit() {
  }

}
